module.exports = __webpack_public_path__ + "img/area_tj.a4d5a69a.png";